import * as actionTypes from "./actionTypes";
import {
  getRole,
  saveLoginInfo,
  deleteLoginInfo,
  getExpirationDate,
  getUserData,
  updateUserData,
  getFCMToken,
} from "../../utils/localStorage";
import api from "../../services";
import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";
import { setPersonalisedExperience } from "./physicianOnboardingActions";
import { getRegPath, THEMES } from "../../constants";
import changeTheme from "../../utils/changeTheme";

export const setSignUpData = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_SIGN_UP_DATA,
      payload,
    });
};

export const setLoginData = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_LOGIN_DATA,
      payload,
    });
};

export const validateData = (type, payload) => {
  return dispatch =>
    dispatch({
      type,
      payload,
    });
};

export const validateSubscription = (type, payload) => {
  return dispatch =>
    dispatch({
      type,
      payload,
    });
};

export const authRedirect = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.AUTH_REDIRECT,
    });
};

export const authInit = (path, loginRedirect) => {
  return dispatch =>
    dispatch({
      type: actionTypes.AUTH_INIT,
      payload: { path, loginRedirect: loginRedirect },
    });
};

export const setLogin = (token, refreshToken, loginObj) => {
  return dispatch => {
    const expirationDate = new Date(new Date().getTime() + 1800 * 1000);
    saveLoginInfo(token, refreshToken, expirationDate, loginObj);
    dispatch({
      type: actionTypes.AUTH_SUCCESS,
    });
  };
};

export const checkAuthTimeout = expirationTime => {
  return dispatch => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 1000);
  };
};

export const logoutApi = () => {
  return dispatch => {
    dispatch(signOut())
  }
}

export const login = cb => {
  return (dispatch, getState) => {
    const user_role = getRole();

    const payload = {
      ...getState().login,
      role: user_role,
      fcm_object: getFCMToken()
        ? {
          active: 1,
          registration_id: getFCMToken() || null,
          type: "web",
          name: "desktop"
        }
        : {},
    };
    dispatch(apiStart(true));
    api
      .login(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(
            setLogin(res.data.token.access, res.data.token.refresh, {
              firstName: res.data.first_name,
              lastName: res.data.last_name,
              user: res.data.id,
              id: res.data.user_type_detail_id,
              user_theme: res.data.user_theme?.app_theme_id__theme_name,
              logo_url: res.data.user_theme?.logo_url,
              image: { src: res.data.image },
              doctor_status: res.data.doctor_status,
              reason: res.data.reason,
              accepted_role: res.data.role,
              notification_count: res.data.notification_unread_count,
              doctor_subscription_details: null,
              qrcode_url: null,
              chat_notify: null,
              fcm_id:res.data.fcm_id
            })
          );

          dispatch(
            setPersonalisedExperience({
              selectedThemeId:
                THEMES.filter(
                  theme =>
                    theme.name === res.data.user_theme?.app_theme_id__theme_name
                )[0]?.id || 1,
              logo: res.data.user_theme?.logo_url && [
                {
                  src: res.data.user_theme?.logo_url,
                },
              ],
            })
          );

          cb();
        } else {
          res.error === "login_error"
            ? cb(res.message[0])
            : errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const emailVerification = (cb = () => { }) => {
  return (dispatch, getState) => {
    const payload = {
      email: getState().registration.email,
    };
    dispatch(apiStart());
    api
      .emailVerification(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          successHandler(res.message[0]);
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const verifyEmail = (cb = () => { }) => {
  return (dispatch, getState) => {
    const payload = {
      email: getState().registration.email,
      secret_code: getState().registration.verificationCode,
    };
    dispatch(apiStart());
    api
      .verifyEmail(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const signUp = (cb = () => { }) => {
  return (dispatch, getState) => {
    const user_role = getRole();
    const payload = {
      email: getState().registration.email,
      first_name: getState().registration.firstName,
      last_name: getState().registration.lastName,
      password: getState().registration.password,
      role: [user_role],
    };

    dispatch(apiStart());
    api
      .signUp(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 201) {
          dispatch(
            setLogin(res.data.token.access, res.data.token.refresh, {
              firstName: res.data.first_name,
              lastName: res.data.last_name,
              user: res.data.id,
              onboarding: true,
            })
          );
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const forgotPasswordRequest = cb => {
  return (dispatch, getState) => {
    const user_role = getRole();
    const payload = {
      email: getState().login.forgotPasswordEmail,
      request_status: "UU",
      role: user_role,
    };

    dispatch(apiStart());
    api
      .forgotPasswordRequest(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 201) {
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const confirmPasswordRequest = cb => {
  return (dispatch, getState) => {
    const payload = {
      email: getState().login.resetUserEmail,
      otp: getState().login.otp,
      confirm_password: getState().login.resetConfirmPassword,
      password: getState().login.resetPassword,
    };

    dispatch(apiStart());
    api
      .confirmPasswordRequest(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 201) {
          successHandler(res.message[0]);
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const setTryAutoLogin = () => {
  return dispatch => {
    const expirationDate = new Date(getExpirationDate());

    if (expirationDate < new Date()) {
      dispatch(logout());
    } else {
      dispatch({
        type: actionTypes.AUTH_SUCCESS,
      });
    }
  };
};

export const updateUserRoleAction = () => {
  return dispatch => {
    const id = getUserData()?.user;
    const user_role = getRole();
    const payload = {
      role: [user_role],
    };
    dispatch(apiStart(true));
    api
      .updateUserRole(id, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          updateUserData({
            accepted_role: res.data.role,
          });
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })

      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getUserDetailIdAction = cb => {
  return dispatch => {
    const user_role = getRole();
    const payload = {
      user_type: user_role,
    };
    dispatch(apiStart(true));
    api
      .getUserDetailId(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          updateUserData({
            id: res.data.user_type_detail_id,
          });
          if (cb) {
            cb();
          }
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })

      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const signOut = () => {
  return dispatch => {
    dispatch(apiStart(true));
    api
      .signOut()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 201) {
          successHandler(res.message[0]);
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess())
      })
      .catch(error => {
        catchHandler(error, dispatch);
      })
    };
};

export const logout = (clearLocalStorage = true) => {
  changeTheme(THEMES.filter(theme => theme.id === 1)[0]);
  deleteLoginInfo();
  return {
    type: actionTypes.AUTH_LOGOUT,
    path: localStorage.getItem("role")
      ? getRegPath("/signin")
      : getRegPath("/"),
  };
};


     

